import { FC } from 'react';

import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import styles from 'pages/dev-page/DevPage.module.css';

export const DevPage: FC = () => {
    const location = useLocation();
    const text = location.state?.name || '';

    return (
        <Box className={styles.devBox}>
            <p>Страница <span>"{text}"</span> находится в разработке</p>
        </Box>

    );
};

export default DevPage;
